/*
 * NOURION Hero: Wortmarke, Claim, Headline, CTAs, USP Zeile.
 * Portierung von src/components/sections/HeroSection.tsx (React/Motion)
 * auf Vanilla JS.
 *
 * Kaskadierter Eintritt: wartet auf die Buehnen Landung, entweder das
 * sessionStorage Flag 'nst-intro-done' (von nourion-stage.js gesetzt,
 * sobald der 1800 ms Kameraanflug fertig ist) oder spaetestens nach
 * 1800 ms selbst, dann blendet jedes Element gestaffelt ein (Klasse
 * .nhero-in, Zeitversatz je Element aus der Quellanalyse: 0, 150, 250,
 * 400, 550, 750, 1100 ms). Bei prefers-reduced-motion: sofort sichtbar.
 *
 * Rueckzugs Rahmen: der Inhaltsblock (#nhero-frame, ohne den Scroll
 * Hinweis) sinkt, schrumpft und blendet beim Wegscrollen der Section aus
 * (Ersatz fuer Framer Motion useScroll/useTransform, offset ['start
 * start', 'end start']). Entfaellt komplett bei reduced motion.
 *
 * Reinitialisiert sich bei shopify:section:load, idempotent (raeumt die
 * vorige Instanz vor jedem Neustart ab).
 */
(function () {
  'use strict';

  var STAGGER = [
    { attr: 'moin', delay: 0 },
    { attr: 'wordmark', delay: 150 },
    { attr: 'h1', delay: 250 },
    { attr: 'subline', delay: 400 },
    { attr: 'cta', delay: 550 },
    { attr: 'promises', delay: 750 },
    { attr: 'scrollhint', delay: 1100 }
  ];
  var INTRO_WAIT_MS = 1800;

  function initHero() {
    if (window.__nheroCleanup) { window.__nheroCleanup(); window.__nheroCleanup = null; }

    var section = document.getElementById('nhero-section');
    if (!section) return;
    var frame = document.getElementById('nhero-frame');
    if (!frame) return;

    var cleanups = [];
    var killed = false;
    window.__nheroCleanup = function () {
      killed = true;
      for (var i = 0; i < cleanups.length; i++) cleanups[i]();
    };

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- Kaskadierter Eintritt ---- */

    function revealAll() {
      var els = section.querySelectorAll('[data-nhero-el]');
      for (var i = 0; i < els.length; i++) els[i].classList.add('nhero-in');
    }

    function revealStaggered() {
      for (var i = 0; i < STAGGER.length; i++) {
        (function (item) {
          var timer = setTimeout(function () {
            if (killed) return;
            var el = section.querySelector('[data-nhero-el="' + item.attr + '"]');
            if (el) el.classList.add('nhero-in');
          }, item.delay);
          cleanups.push(function () { clearTimeout(timer); });
        })(STAGGER[i]);
      }
    }

    if (reduce) {
      revealAll();
    } else {
      var already = false;
      try { already = sessionStorage.getItem('nst-intro-done') === '1'; } catch (e) { /* Safari privat */ }

      if (already) {
        revealStaggered();
      } else {
        var settled = false;
        var t0 = performance.now();
        var raf = 0;
        (function poll() {
          if (killed || settled) return;
          var done = false;
          try { done = sessionStorage.getItem('nst-intro-done') === '1'; } catch (e) { /* Safari privat */ }
          var elapsed = performance.now() - t0;
          if (done || elapsed >= INTRO_WAIT_MS) {
            settled = true;
            revealStaggered();
            return;
          }
          raf = requestAnimationFrame(poll);
        })();
        cleanups.push(function () { settled = true; cancelAnimationFrame(raf); });
      }
    }

    /* ---- Rueckzugs Rahmen: sinkt, schrumpft, blendet beim Wegscrollen aus ---- */

    if (!reduce) {
      var ticking = false;

      function clamp01(v) { return Math.min(1, Math.max(0, v)); }

      function updateExit() {
        ticking = false;
        var scrollY = window.scrollY || window.pageYOffset || 0;
        var rect = section.getBoundingClientRect();
        var top = rect.top + scrollY;
        var height = section.offsetHeight;
        if (height <= 0) return;
        var p = clamp01((scrollY - top) / height);
        var y = p * 150;
        var scale = 1 - p * 0.1;
        var opacity = p <= 0.75 ? 1 - (p / 0.75) : 0;
        frame.style.transform = 'translateY(' + y + 'px) scale(' + scale + ')';
        frame.style.opacity = String(opacity);
      }

      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(updateExit); }
      }

      updateExit();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      cleanups.push(function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero);
  } else {
    initHero();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#nhero-section')) initHero();
  });
})();
